<script setup lang="ts">
import moment from 'moment';
import SimpleEquipStatus from './simple-equip-status.vue';
import DatePicker from '~/client/components/DatePicker.vue';
import CalendarUtils from '~/client/utils/CalendarUtils';

const props = withDefaults(defineProps<{
  isStatusTab?: boolean
}>(), {
  isStatusTab: false
})

const selectDate = ref(moment().format("YYYY-MM-DD"));

function setDate(date: any){
  selectDate.value = date;
}

const selectType = ref('status');

</script>

<template>
  <div class="event-table">
    <div class="header">
      <div class="title">
        이벤트
      </div>
      <div class="date-tab-wrapper">
        <div class="date-select" v-if="selectType === 'history' || isStatusTab === false">
          <DatePicker
          :modelValue="selectDate"
          @setVmodel="setDate"
          >
          <template #contents>
            <div class="input-wrapper">
              <input type="text" class="calendar-icon text" :value="CalendarUtils.setDateFormat(selectDate.toString())" />
              <div class="carot">
                <img src="@/assets/images/toc/CaretDown.svg"></img>            
              </div>
            </div>
          </template>
          </DatePicker>
        </div>
        <div class="event-tab" v-if="props.isStatusTab">
          <div class="event-tab">
            <ul class="nav nav-pills" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="event-now-tab" data-bs-toggle="tab"
                  data-bs-target="#event-now-tab-pane" type="button" role="tab" aria-controls="event-now-tab-pane"
                  aria-selected="true" @click="selectType = 'status'">상태</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="event-list-tab" data-bs-toggle="tab" data-bs-target="#event-list-tab-pane"
                  type="button" role="tab" aria-controls="event-list-tab-pane" aria-selected="false"
                  @click="selectType = 'history'"
                  >이력</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
  
    </div>
    <div class="content h-100">
      <div class="tab-content h-100" id="myTabContent" v-if="props.isStatusTab">
        <div class="tab-pane fade show active h-100" id="event-now-tab-pane" role="tabpanel" aria-labelledby="event-now-tab"
          tabindex="0">
          <div class="event-now-table row h-100">
            <div class="col-4">
              <table class="table h-100">
                <colgroup>
                  <col width="40%"></col>
                  <col width="60%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th>상태</th>
                    <th>종류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'on'"></SimpleEquipStatus>
                    </td>
                    <td>인버터 동작유무</td>
                  </tr>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'normal'"></SimpleEquipStatus>
                    </td>
                    <td>태양전지 과전압</td>
                  </tr>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'normal'"></SimpleEquipStatus>
                    </td>
                    <td>태양전지 저전압</td>
                  </tr>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'normal'"></SimpleEquipStatus>
                    </td>
                    <td>태양전지 과전류</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-4">
              <table class="table h-100">
                <colgroup>
                  <col width="40%"></col>
                  <col width="60%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th>상태</th>
                    <th>종류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'normal'"></SimpleEquipStatus>
                    </td>
                    <td>인버터 IGBT에러</td>
                  </tr>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'normal'"></SimpleEquipStatus>
                    </td>
                    <td>인버터 과온</td>
                  </tr>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'normal'"></SimpleEquipStatus>
                    </td>
                    <td>계통 과전압</td>
                  </tr>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'normal'"></SimpleEquipStatus>
                    </td>
                    <td>계통 저전압</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-4">
              <table class="table h-100">
                <colgroup>
                  <col width="40%"></col>
                  <col width="60%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th>상태</th>
                    <th>종류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'fault'"></SimpleEquipStatus>
                    </td>
                    <td>계통 과전류</td>
                  </tr>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'warning'"></SimpleEquipStatus>
                    </td>
                    <td>계통 과주파수</td>
                  </tr>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'warning'"></SimpleEquipStatus>
                    </td>
                    <td>계통 저주파수</td>
                  </tr>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'warning'"></SimpleEquipStatus>
                    </td>
                    <td>단독운전 (정전)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="event-list-tab-pane" role="tabpanel" aria-labelledby="event-list-tab"
          tabindex="0">
          <table class="table">
            <colgroup>
              <col width="10%">
              </col>
              <col width="15%">
              </col>
              <col width="20%">
              </col>
              <col width="20%">
              </col>
              <col width="15%">
              </col>
              <col width="20%">
              </col>
            </colgroup>
            <thead>
              <tr>
                <th>상태</th>
                <th>설비명</th>
                <th>발생시간</th>
                <th>종료시간</th>
                <th>이벤트 상태</th>
                <th>이벤트 내용</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'fault'"></SimpleEquipStatus>
                </td>
                <td>인버터 #B</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>정상</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
            </tbody>
          </table>
        </div>
        
      </div>
      <div v-else>
        <table class="table">
            <colgroup>
              <col width="10%">
              </col>
              <col width="15%">
              </col>
              <col width="20%">
              </col>
              <col width="20%">
              </col>
              <col width="15%">
              </col>
              <col width="20%">
              </col>
            </colgroup>
            <thead>
              <tr>
                <th>상태</th>
                <th>설비명</th>
                <th>발생시간</th>
                <th>종료시간</th>
                <th>이벤트 상태</th>
                <th>이벤트 내용</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'fault'"></SimpleEquipStatus>
                </td>
                <td>인버터 #B</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>정상</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
              <tr>
                <td>
                  <SimpleEquipStatus :eqStatus="'warning'"></SimpleEquipStatus>
                </td>
                <td>인버터 #A</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>통신에러</td>
                <td>태양전지 과전류, 계통 과전류</td>
              </tr>
            </tbody>
          </table>
      </div>

    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/design-toc/event-table.scss"
</style>